import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "reason"]

  connect() {
    this.toggleDetailsRequirement()
  }

  toggleDetailsRequirement() {
    if (!this.hasDetailsTarget) return

    this.detailsTarget.required = this.reasonTargets.some((reason) => {
      return reason.checked && reason.value === "other_cancellation_reason"
    })
  }
}
